import {
  required,
  minLength,
  TextInput,
  SimpleForm,
  AutocompleteInput,
} from 'react-admin';
import { ReferenceInput } from '@components/index';
import QuickreplyIcon from '@mui/icons-material/Quickreply';

const validateRequired = [required()];
const validateShortcut = [required(), minLength(2, 'resources.ticket-quick-reply.validations.shortcutMinLength')];

const ensureSlashPrefix = (value: string) =>
  value && !value.startsWith('/') ? `/${value}` : value || '';

export const QuickReplyForm = (props: Record<string, unknown>) => (
  <SimpleForm warnWhenUnsavedChanges {...props}>
    <TextInput
      source="shortcut"
      label="resources.ticket-quick-reply.fields.shortcut"
      validate={validateShortcut}
      format={ensureSlashPrefix}
      parse={ensureSlashPrefix}
      fullWidth
      helperText="resources.ticket-quick-reply.helpers.shortcut"
    />
    <TextInput
      source="title"
      label="resources.ticket-quick-reply.fields.title"
      validate={validateRequired}
      fullWidth
    />
    <TextInput
      source="content"
      label="resources.ticket-quick-reply.fields.content"
      validate={validateRequired}
      multiline
      rows={5}
      fullWidth
      helperText="resources.ticket-quick-reply.helpers.content"
    />
    <ReferenceInput source="ticketQueueId" reference="ticket-queue">
      <AutocompleteInput
        optionText="name"
        label="resources.ticket-quick-reply.fields.ticketQueueId"
        filterToQuery={(searchText: string) => ({ name_q: searchText })}
        fullWidth
      />
    </ReferenceInput>
  </SimpleForm>
);

export { QuickReplyList } from './List';
export { QuickReplyCreate } from './Create';
export { QuickReplyEdit } from './Edit';
export const QuickReplyIcon = QuickreplyIcon;
